import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["options", "className", "components", "classNames"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { UI } from "../UI.js";
/**
 * Render a dropdown component for navigation in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Dropdown(props) {
  const {
      options,
      className,
      components,
      classNames
    } = props,
    selectProps = _objectWithoutProperties(props, _excluded);
  const cssClassSelect = [classNames[UI.Dropdown], className].join(" ");
  const selectedOption = options === null || options === void 0 ? void 0 : options.find(_ref => {
    let {
      value
    } = _ref;
    return value === selectProps.value;
  });
  return React.createElement("span", {
    "data-disabled": selectProps.disabled,
    className: classNames[UI.DropdownRoot]
  }, React.createElement(components.Select, _objectSpread({
    className: cssClassSelect
  }, selectProps), options === null || options === void 0 ? void 0 : options.map(_ref2 => {
    let {
      value,
      label,
      disabled
    } = _ref2;
    return React.createElement(components.Option, {
      key: value,
      value: value,
      disabled: disabled
    }, label);
  })), React.createElement("span", {
    className: classNames[UI.CaptionLabel],
    "aria-hidden": true
  }, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, React.createElement(components.Chevron, {
    orientation: "down",
    size: 18,
    className: classNames[UI.Chevron]
  })));
}